import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { selectors } from '../../Stream';
import { getDataEntities } from '../../redux/entities/selectors';
import { reduxKey } from './constants';
import { getStreamId } from './helpers';
function getStoreSlice(state) {
    return state[reduxKey] || {
        isNewCollectionSaving: false,
        deviations: {}
    };
}
function getUserCollectionEntities(state) {
    const { collections  } = getDataEntities(state);
    if (!collections) {
        return {};
    }
    return collections;
}
function getCollectionsRaw(state, isPrivate) {
    const collectionIds = selectors.getItems(state, getStreamId(isPrivate)) || [];
    if (!collectionIds.length) {
        return [];
    }
    return getCollectionsByFolderId(state, collectionIds);
}
function getCollectionsByFolderId(state, folderIds) {
    const collections = getUserCollectionEntities(state);
    return folderIds.filter((id)=>collections.hasOwnProperty(id)).map((collectionId)=>collections[collectionId]);
}
function getChangeType(added, removed, kept) {
    if (!added) {
        if (!removed) {
            return 'none';
        }
        if (!kept) {
            return 'removeAll';
        }
        if (removed === 1) {
            return 'removeOne';
        }
        return 'removeSome';
    }
    if (removed) {
        return 'misc';
    }
    if (added > 1) {
        return 'addMany';
    }
    return 'addOne';
}
function getDeviationState(state, deviationId) {
    const slice = getStoreSlice(state);
    return slice === null || slice === void 0 ? void 0 : slice.deviations[deviationId];
}
export function getCollection(state, folderId) {
    return getUserCollectionEntities(state)[folderId];
}
export function getUserCollections(state, deviationId, isPrivateCollections) {
    const slice = getDeviationState(state, deviationId);
    const selectedCollectionsKey = isPrivateCollections ? 'selectedPrivateCollections' : 'selectedCollections';
    const collections = slice ? getCollectionsRaw(state, isPrivateCollections).map((collection)=>_object_spread_props(_object_spread({}, collection), {
            isSelected: slice[selectedCollectionsKey].includes(collection.folderId)
        })) : [];
    const streamId = getStreamId(isPrivateCollections);
    const isInitialized = isPrivateCollections ? slice === null || slice === void 0 ? void 0 : slice.isInitializedForPrivateCollecting : slice === null || slice === void 0 ? void 0 : slice.isInitializedForCollecting;
    const streamInfo = {
        streamId,
        isInitialized: !!isInitialized,
        hasMore: selectors.hasMore(state, streamId),
        isFetching: selectors.isFetching(state, streamId),
        errorMsg: selectors.getErrorMsg(state, streamId),
        collections
    };
    return streamInfo;
}
export function getTotalCountOfCollectedDeviations(state, deviationId, isPrivateCollections) {
    const { collections  } = getUserCollections(state, deviationId, isPrivateCollections);
    return collections.reduce((acc, collection)=>acc + collection.size, 0);
}
export function getUserCollectionsHasMore(state, deviationId, isPrivateCollections) {
    var _getUserCollections;
    return !!((_getUserCollections = getUserCollections(state, deviationId, isPrivateCollections)) === null || _getUserCollections === void 0 ? void 0 : _getUserCollections.hasMore);
}
export function getUserCollectionsCount(state, deviationId, isPrivateCollections) {
    var _getUserCollections, _getUserCollections_collections;
    var _getUserCollections_collections_length;
    return (_getUserCollections_collections_length = (_getUserCollections = getUserCollections(state, deviationId, isPrivateCollections)) === null || _getUserCollections === void 0 ? void 0 : (_getUserCollections_collections = _getUserCollections.collections) === null || _getUserCollections_collections === void 0 ? void 0 : _getUserCollections_collections.length) !== null && _getUserCollections_collections_length !== void 0 ? _getUserCollections_collections_length : 0;
}
export function getIsNewCollectionSaving(state) {
    return getStoreSlice(state).isNewCollectionSaving;
}
export function getUpdatedEntities(state, deviation, isPrivateCollections) {
    const entities = {
        collections: {}
    };
    const deviationState = getDeviationState(state, deviation.deviationId);
    var _deviationState_savedCollections;
    const currentFolders = (_deviationState_savedCollections = deviationState === null || deviationState === void 0 ? void 0 : deviationState.savedCollections) !== null && _deviationState_savedCollections !== void 0 ? _deviationState_savedCollections : [];
    var _deviationState_;
    const selectedFolders = (_deviationState_ = deviationState === null || deviationState === void 0 ? void 0 : deviationState[isPrivateCollections ? 'selectedPrivateCollections' : 'selectedCollections']) !== null && _deviationState_ !== void 0 ? _deviationState_ : [];
    const addedFolders = selectedFolders.filter((id)=>!currentFolders.includes(id));
    const removedFolders = currentFolders.filter((id)=>!selectedFolders.includes(id));
    const collections = getUserCollectionEntities(state);
    const updateFolderSize = (sizeChange, folderId)=>{
        const collection = collections[folderId];
        if (!collection) {
            return;
        }
        const newSize = collection.size + sizeChange;
        entities.collections[folderId] = _object_spread_props(_object_spread({}, collection), {
            size: newSize,
            thumb: newSize === 0 ? null : collection.thumb || deviation
        });
    };
    addedFolders.forEach((id)=>updateFolderSize(1, id));
    removedFolders.forEach((id)=>updateFolderSize(-1, id));
    return entities;
}
export function getNewFolderNameBlacklist(state, isPrivateCollections) {
    const collections = getCollectionsRaw(state, isPrivateCollections);
    return collections.map((collection)=>collection.name);
}
export function getIsDeviationInitialized(state, deviationId, isPrivateCollections) {
    const slice = getStoreSlice(state);
    return slice.deviations.hasOwnProperty(deviationId) && (isPrivateCollections ? slice.deviations[deviationId].isInitializedForPrivateCollecting : slice.deviations[deviationId].isInitializedForCollecting);
}
export function getSelectedFolderIds(state, deviationId, isPrivateCollections) {
    const slice = getDeviationState(state, deviationId);
    var _ref;
    return (_ref = isPrivateCollections ? slice === null || slice === void 0 ? void 0 : slice.selectedPrivateCollections : slice === null || slice === void 0 ? void 0 : slice.selectedCollections) !== null && _ref !== void 0 ? _ref : [];
}
export function getSpecialDefaultFolderId(state, isPrivateCollections) {
    const specialFolderName = isPrivateCollections ? 'Private' : 'Featured';
    const collections = getCollectionsRaw(state, isPrivateCollections);
    const specialFolder = collections.find((f)=>f.name === specialFolderName);
    return specialFolder && specialFolder.folderId;
}
export function getChangeDetails(state, deviationId, isPrivateCollections) {
    const selectedCollectionsKey = isPrivateCollections ? 'selectedPrivateCollections' : 'selectedCollections';
    var _getDeviationState;
    const { [selectedCollectionsKey]: selected = [] , savedCollections: saved = [] , isFavourite: wasFavourite = false , isPrivatelyCollected: wasPrivatelyCollected = false  } = (_getDeviationState = getDeviationState(state, deviationId)) !== null && _getDeviationState !== void 0 ? _getDeviationState : {};
    const added = selected.filter((f)=>!saved.includes(f));
    const removed = saved.filter((f)=>!selected.includes(f));
    const kept = saved.filter((f)=>selected.includes(f));
    const willBePrivatelyCollected = isPrivateCollections && selected.length > 0;
    const willBeFavourite = !isPrivateCollections && selected.length > 0;
    return {
        added,
        removed,
        selected,
        saved,
        changeType: getChangeType(added.length, removed.length, kept.length),
        wasFavourite,
        willBeFavourite,
        wasPrivatelyCollected,
        willBePrivatelyCollected
    };
}
// TODO: just kill this, it's terrible for perf
// @deprecated
export function getDeviationPatchedWithStoreState(state, deviation) {
    const slice = getStoreSlice(state).deviations[deviation.deviationId];
    if (!slice) {
        return deviation;
    }
    return _object_spread_props(_object_spread({}, deviation), {
        isFavourited: slice.isFavourite,
        stats: deviation.stats && _object_spread_props(_object_spread({}, deviation.stats), {
            favourites: slice.faveCount
        })
    });
}
export function getIsFavourite(state, deviation) {
    const slice = getDeviationState(state, deviation.deviationId);
    var _slice_isFavourite, _ref;
    return (_ref = (_slice_isFavourite = slice === null || slice === void 0 ? void 0 : slice.isFavourite) !== null && _slice_isFavourite !== void 0 ? _slice_isFavourite : deviation.isFavourited) !== null && _ref !== void 0 ? _ref : false;
}
export function getIsPrivatelyCollected(state, deviation) {
    var _deviation_extended;
    const slice = getDeviationState(state, deviation.deviationId);
    var _slice_isPrivatelyCollected, _ref;
    return (_ref = (_slice_isPrivatelyCollected = slice === null || slice === void 0 ? void 0 : slice.isPrivatelyCollected) !== null && _slice_isPrivatelyCollected !== void 0 ? _slice_isPrivatelyCollected : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.isPrivatelyCollected) !== null && _ref !== void 0 ? _ref : false;
}
export function getFaveCount(state, deviation) {
    var _deviation_stats;
    const slice = getDeviationState(state, deviation.deviationId);
    var _slice_faveCount, _ref;
    return (_ref = (_slice_faveCount = slice === null || slice === void 0 ? void 0 : slice.faveCount) !== null && _slice_faveCount !== void 0 ? _slice_faveCount : (_deviation_stats = deviation.stats) === null || _deviation_stats === void 0 ? void 0 : _deviation_stats.favourites) !== null && _ref !== void 0 ? _ref : 0;
}
export function getIsFaveLoading(state, deviation) {
    const slice = getDeviationState(state, deviation.deviationId);
    var _slice_isLoading;
    return (_slice_isLoading = slice === null || slice === void 0 ? void 0 : slice.isLoading) !== null && _slice_isLoading !== void 0 ? _slice_isLoading : false;
}
